<template>
  <div class="p-3">
    <div id="pop-up" v-if="loading == true">
      <div class="">
        <b-spinner
          variant="primary"
          style="width: 4rem; height: 4rem"
          label=""
        ></b-spinner>
      </div>
    </div>
    <b-modal id="modal-explain-edit" hide-header hide-footer size="lg">
      <explain-edit></explain-edit>
    </b-modal>
    <div :key="renderData" class="createQuestion">
      <h5>{{ $t("question_list.edit_question") }}</h5>
      <div class="">
        <div class="d-flex align-items-center justify-content-between">
          <div :key="renderData" class="d-flex  align-items-center">
            <p class="pr-2 text-nowrap">
              {{ $t("question_list.label.category") }}:
            </p>
            <multiselect
              v-model="cateSelected"
              :close-on-select="true"
              :clear-on-select="false"
              label="category"
              :multiple="true"
              :options="categories"
              :placeholder="$t('question_list.label.placeholder_category')"
              track-by="category"
              :hide-selected="true"
              :max-height="150"
              class=""
              @select="checkCategoryPermission"
            >
            </multiselect>
          </div>
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("question_list.label.type") }}:</p>
              <select
                class="createQuestion-dropdown"
                v-model="form.type"
                @change="typeOfQuestion"
              >
                <option
                  v-for="tOfQ in typeOfQuestions"
                  :key="tOfQ.id"
                  :value="tOfQ.value"
                >
                  {{ tOfQ.text }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2" v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'">
                {{ $t("question_list.label.answer") }}:
              </p>
              <select
                v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'"
                class="createQuestion-dropdown"
                @change="alphabetOfQuestion"
                v-model="typeOfAnswer"
                :key="imageReRender"
              >
                <option
                  v-for="tOfA in typeOfAnswers"
                  :key="tOfA.id"
                  :value="tOfA.value"
                >
                  {{ tOfA.text }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("question_list.label.difficulty") }}:</p>
              <select
                class="createQuestion-dropdown"
                v-model="editQuestion.data.difficulty"
              >
                <option
                  v-for="tOfD in difficulty"
                  @click="difficultyOfQuestion"
                  :key="tOfD.id"
                  :value="tOfD.difficulty"
                >
                  {{ tOfD.difficulty }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("question_list.label.score") }}:</p>
              <input
                v-model="editQuestion.data.score"
                type="number"
                placeholder="0"
                class="createQuestion-dropdown p-3"
                style="width: 70px"
              />
            </div>
          </div>
        </div>

        <div class="row justify-content-around">
            <div class="col-4 p-0"></div>
            <div class="col-8 d-flex align-items-center justify-content-end mb-4">
                <div class="col-8 d-flex align-items-center p-0">
                    <label class="typo__label mr-2">Tags:</label>
                    <multiselect
                        v-model="tagsSelected"
                        :placeholder="$t('question_list.label.placeholder_category')"
                        label="name"
                        track-by="id"
                        :options="optionsTags"
                        :multiple="true"
                        :taggable="true"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :hide-selected="true"
                        :max-height="150"
                    >
                    </multiselect>

                </div>
            </div>
        </div>

        <div class="row justify-content-around">
          <div class="col left-embed p-0">
            <div class="title-topic__textArena">
              <textarea
                v-model="titleTopic"
                disabled
                rows="1"
                maxlength="1500"
                class="w-100"
              ></textarea>
            </div>
            <div
              class="d-flex flex-column align-items-center embed-image-video"
              style="height:78%;"
            >
              <!--kiểm tra ảnh/video cũ / ảnh/video mới -> show/hide input -->
              <ion-icon
                style="font-size: 60px; margin-bottom: 10px"
                name="cloud-upload-outline"
                v-if="
                  !editQuestion.data.image_path &&
                    !file &&
                    !imageUpload &&
                    !editQuestion.data.video_path &&
                    !editQuestion.data.embed_image_video &&
                    !embedUpload
                "
              ></ion-icon>
              <!--kiểm tra ảnh/video cũ / ảnh/video mới -> show/hide input -->
              <label
              style="white-space: nowrap;"
                v-if="
                  !editQuestion.data.image_path &&
                    !file &&
                    !imageUpload &&
                    !editQuestion.data.video_path &&
                    !editQuestion.data.embed_image_video &&
                    !embedUpload
                "
                class="label-uploadImage"
                for="uploadImage"
                >{{ $t("question_list.label.upload_file") }}</label
              >
              <input
                v-if="
                  !imageUpload &&
                    !editQuestion.data.image_path &&
                    !editQuestion.data.video_path &&
                    !editQuestion.data.embed_image_video &&
                    !embedUpload
                "
                type="file"
                @change="handleFileUpload"
                class=""
                id="uploadImage"
              />
              <div
                v-if="
                  imageUpload ||
                    editQuestion.data.image_path ||
                    editQuestion.data.video_path ||
                    file
                "
                id="preview"
                class=""
              >
                <img
                  v-if="editQuestion.data.image_path"
                  :src="editQuestion.data.image_s3"
                />
                <video
                  style="width:100%; height:100%;"
                  v-if="editQuestion.data.video_path"
                  controls
                  :src="editQuestion.data.video_s3"
                  id="video-preview"
                ></video>
                <video
                  style="width:100%; height:100%;"
                  v-if="file"
                  :src="file"
                  controls
                  id="video-preview"
                ></video>
                <img v-if="imageUpload" :src="imageUpload" />
                <button @click="removeFile">X</button>
              </div>
              <div
                v-if="
                  !imageUpload &&
                    !editQuestion.data.image_path &&
                    !editQuestion.data.video_path &&
                    !file &&
                    !embedUpload &&
                    !editQuestion.data.embed_image_video
                "
                class="d-flex justify-content-between embed-image my-2"
              >
                <input v-model="form.embed_image_video" type="text" v-if="!embedUpload"/>
                <button @click="embed()"  v-if="!embedUpload">
                  {{ $t("question_list.label.embed_image") }}
                </button>
              </div>
              <button
                id="removeEmbed1"
                v-if="embedUpload || editQuestion.data.embed_image_video"
                @click="removeEmbed"
              >
                X
              </button>

              <!--5-->
              <div id="embedUpload">
                <embed
                  width="500"
                  height="250"
                  :src="editQuestion.data.embed_image_video"
                  frameborder="0"
                  allowfullscreen
                />
              </div>
            </div>
          </div>
          <div class="col">
            <div
              v-if="
                (editQuestion.data.embed_audio === '' ||
                  !editQuestion.data.embed_audio) &&
                  embedAudio === ''
              "
              class="d-flex align-items-center justify-content-between mb-4"
            >
              <div class="upload-audio">
                <button
                  class="upload-audio-button"
                  for="upload-audio-input-edit-topic"
                  type="button"
                >
                  <b-icon
                    icon="music-note-beamed"
                    font-scale="1.5"
                    style="margin-right: 5px"
                    variant="danger"
                  ></b-icon>
                  <label style="white-space: nowrap;" for="upload-audio-input-edit-topic">{{
                    $t("question_list.label.audio")
                  }}</label>
                </button>
                <b-form-file
                  accept="audio/*"
                  @change="handleAudioUpload($event)"
                  class="pr-1"
                  id="upload-audio-input-edit-topic"
                ></b-form-file>
              </div>
              <audio
                v-show="editQuestion.data.audio_path"
                :src="editQuestion.data.audio_s3"
                id="audio-preview"
                controls
              />
              <audio
                v-show="audioUpload"
                id="form"
                :src="audioUpload"
                controls
              />
              <ion-icon
                @click="removeAudio"
                v-show="editQuestion.data.audio_path || audioUpload"
                name="close-circle-outline"
                style="font-size: 40px"
              ></ion-icon>
            </div>
            <div
            v-if="
                !editQuestion.data.audio_path &&
                  (!audioUpload || audioUpload == '')
              "
              class="embed-audio"
            >
              <div class="embed-input">
                <b-button @click="audioEmbedLeft">
                  <b-icon
                    icon="box-arrow-up"
                    font-scale="1.2"
                    variant="success"
                  ></b-icon>
                  <span>{{ $t("question_list.label.embed_video_audio") }}</span>
                </b-button>
                <input
                  v-model="form.embed_audio"
                  type="text"
                  :placeholder="$t('question_list.label.embed_video_audio_placeHolder')"
                  id="embed_audio_link"
                  class="ml-2"
                />
              </div>
              <div id="audio_embed_view_topic" v-html="editQuestion.data.embed_audio">
                {{ editQuestion.data.embed_audio }}
              </div>
              <ion-icon
                class="remove-embed-audio-btn"
                @click="removeEmbedAudio"
                v-show="
                  (this.editQuestion.data.embed_audio &&
                    this.editQuestion.data.embed_audio != '' &&
                    this.form.embed_audio != null) ||
                    embedAudio != ''
                "
                name="close-circle-outline"
              ></ion-icon>
            </div>
            <div
              class="answer-options d-flex"
              v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'"
            >
              <p class="text-nowrap">
                {{ $t("question_list.label.answer_option") }}:
              </p>
              <!-- one choice / multiple choice-->
              <select
                class=""
                @change="manyAnswerOfQuestion"
                v-model="valueAnswerOption"
              >
                <option
                  v-for="tOfAO in answerOptionOfQuestions"
                  :key="tOfAO.id"
                  :value="tOfAO.value"
                >
                  {{ tOfAO.text }}
                </option>
              </select>
              <p class="ml-5 text-nowrap" style="width: 17%;">
                {{ $t("question_list.label.answer_type") }}:
              </p>
              <!-- text / image-->
              <select
                v-model="valueTypeOfAnswer"
                @change="answerTypeOfQuestion"
              >
                <option
                  v-for="option in optionValueTypeOfAnswer"
                  :value="option.value"
                  :key="option.id"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="question-input__textArena">
              <ckeditor
                :config="editorConfig"
                :editor="editor"
                @ready="onReady"
                v-model="editQuestion.data.title"
                @keyup="charCountTitle()"
                name=""
                id=""
                class="edit-question"
                rows="3"
                maxlength="1500"
                :placeholder="$t('question_list.label.placeholder_title')"
              ></ckeditor>
              <!-- <span>{{ editQuestion.data.title.length }} / 1500</span> -->
            </div>
            <div
              class="w-100 justify-content-between d-flex align-items-center mt-3"
            >
              <button v-b-modal.modal-explain-edit class="btn-explanation">
                {{ $t("question_list.label.explanation") }}
              </button>
              <div class="d-flex align-items-center">
                <p v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'" class="pr-1">
                  {{ $t("question_list.label.number_answer") }}:
                </p>
                <select
                  v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'"
                  class="createQuestion-dropdown"
                  @change="numberAnswerOfQuestion"
                  v-model="editQuestion.data.manyAnswer"
                  :key="imageReRender"
                >
                  <option
                    v-for="tOfNA in numberAnswerOfQuestions"
                    :key="tOfNA.id"
                  >
                    {{ tOfNA }}
                  </option>
                </select>
              </div>
              <div class="d-flex align-items-center">
                <p class="pr-1">{{ $t("question_list.label.status") }}:</p>
                <select
                  class="createQuestion-dropdown"
                  id=""
                  @change="statusOfQuestion"
                  v-model="form.status"
                >
                  <option
                    v-for="stt in statusOfQuestions"
                    :key="stt.id"
                    :value="stt.value"
                  >
                    {{ $t(stt.text) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h5 v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'" class="pt-2">
        {{ $t("question_list.label.answer") }}
      </h5>
      <div
        v-if="editQuestion.data.type != 'Writing' && editQuestion.data.type != 'Speaking'"
        class="formCreateQuestion"
        :key="imageReRender"
      >
        <div
          v-for="(item, index) in editQuestion.data.answer"
          :key="index"
          class="answerQuestion m-1"
        >
          <p>{{ item.ans_id }}.</p>
          <div
            v-if="
              !item.image &&
                !answerUpload[index] &&
                editQuestion.data.isText == false
            "
            :key="imageReRender"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <label for="upload-image__invisible">
              <ion-icon
                name="cloud-upload-outline"
                @click="uploadImageAnswer(index)"
                style="font-size: 30px"
              ></ion-icon>
            </label>
            <input
              type="file"
              @change="handleAnswerUpload($event, [index])"
              class="upload-image__invisible"
              :id="'uploadImage' + index"
            />
          </div>
          <div v-if="editQuestion.data.isText == true" class="mt-2">
            <ckeditor
              :editor="editor"
              :config="editorConfigAnswer"
              @ready="onReady"
              v-model="editQuestion.data.answer[index].ans_value"
              @input="
                charCount(editQuestion.data.answer[index].ans_value, index)
              "
              name=""
              id=""
              rows="3"
              maxlength="1500"
              :placeholder="$t('question_list.label.placeholder_answer')"
              class="answer-input__text "
            ></ckeditor>
          </div>
          <div
            style=""
            v-if="
              (item.image || answerUpload[index]) &&
                editQuestion.data.isText == false
            "
            class="preview"
            :id="'preview' + index"
          >
            <img
              v-if="item.image"
              :src="item.image_answer_s3"
              :key="imageReRender"
            />
            <img
              v-if="answerUpload[index]"
              :key="imageReRender"
              :src="answerUpload[index]"
            />
            <button @click="removeAnswerImage(index)">
              {{ $t("group_topic_list.button.remove_image") }}
            </button>
          </div>
          <!-- Choose Input -->
          <div :key="updateCorrectAnswer" class="text-answer">
            <input
              v-if="editQuestion.data.answer_option === 'Multiple choice'"
              type="checkbox"
              name="checkbox"
              :id="'checkbox' + [index + 1]"
              @change="getMultiCorrectAnswer(index)"
              :checked="isTrueSet[index]"
              class="checkboxInvisible m-3"
            />
            <input
              v-if="editQuestion.data.answer_option === 'One choice'"
              type="radio"
              name="radio"
              :id="'checkbox' + [index + 1]"
              class="checked m-3"
              :checked="isTrueSet[index]"
              @change="getCorrectAnswer(index)"
            />
          </div>
        </div>
      </div>
      <div class="mt-3 float-right">
        <b-button @click="hideModal" variant="danger">{{
          $t("question_list.label.cancel")
        }}</b-button>
        <b-button
          v-if="disable == true"
          @click="
            EditQuestions();
            hideModal;
          "
          style="margin-left: 1rem"
          variant="primary"
          >{{ $t("question_list.label.edit") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import ExplainEdit from "./QuestionExplainEditModal.vue";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";

export default {
  props: {
    callback: Function,
    rowTopicItem: Number,
    titleTopic: Text
  },
  components: {
    Multiselect,
    ExplainEdit
  },
  data() {
    return {

        optionsTags: [],

        editor: DecoupledEditor,
        editorConfig: {
            toolbar: [ 'bold', 'italic','underline'],
            placeholder: this.$t('question_list.label.placeholder_title')
        },
        editorConfigAnswer: {
            toolbar: ['bold', 'italic', 'underline'],
            placeholder: this.$t("question_list.label.placeholder_answer")
        },
      disable: true,
      loading: false,
      renderData: 0,
      imageReRender: 10,
      isTrueSet: [],
      updateCorrectAnswer: 0,
      categories: [],
      cateSelected: [],
      tagsSelected: [],
      isText: "",
      typeOfQuestions: [
        { text: "Listening", value: 0 },
        { text: "Writing", value: 1 },
        { text: "Reading", value: 2 },
        { text: "Speaking", value: 3 }
      ],
      typeOfAnswers: [
        { text: "Alphabet", value: 0 },
        { text: "Number", value: 1 }
      ],
      typeOfAnswer: 0,
      statusOfQuestions: [
        { text: "Active", value: 0 },
        { text: "Inactive", value: 1 }
      ],
      answerOptionOfQuestions: [
        { text: "One choice", value: 0 },
        { text: "Multiple choice", value: 1 }
      ],

      numberAnswerOfQuestions: [1, 2, 3, 4, 5, 6],
      imageUpload: "",
      answerUpload: [],
      embedUpload: "",
      audioUpload: "",
      embedAudio: "",
      correctAnswer: [],
      file: "",
      filterData: {
        search: "",
        page: 1,
        selected: {
          category: null,
          typeQuestion: null,
          typeOfQuestion: null,
          difficulty: null,
          score_from: null,
          score_to: null,
          tags: null
        }
      },
      valueTypeOfAnswer: "",
      optionValueTypeOfAnswer: [
        { text: "Text", value: 1 },
        { text: "Images", value: 0 }
      ],
      valueTypeOfAnswers: [
        ["A", "B", "C", "D", "E", "F"],
        [1, 2, 3, 4, 5, 6]
      ],
      valueAnswerOption: "",
      form: {
        title: "",
        type: "",
        status: "",
        score: "",
        difficulty: "",
        category: [],
        image_path: "",
        video_path: "",
        embed_image_video: "",
        audio_path: "",
        embed_audio: "",
        answer_option: "One choice",
        answer: [],
        image: [],
        answer_text: [],
        number_answer: "",
        id_topic: "",
        id_ans_update: [],
        tags: []
      }
    };
  },
  computed: {
    ...mapState("config", ["category", "difficulty"]),
    ...mapState("question", ["editQuestion", "explain", "explain_path", "changeListTags"]),
    ...mapState("auth", ["user"]),

    categoryIdsAllow() {
      return this.user?.category_ids_apply || "";
    }
  },
  methods: {
      onReady(editor) {
          editor.ui
              .getEditableElement()
              .parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              editor.ui.getEditableElement()
          );
      },
    // lay dap an dung
    getMultiCorrectAnswer(index) {
      const answer = this.form.answer;
      this.form.answer = [];

      // update du lieu
      for (let i = 0; i < this.form.number_answer; i++) {
        // lay id update
        if (!this.form.id_ans_update.includes(i)) {
          this.form.id_ans_update.push(i);
        }
        const reqData = {
          ans_id: answer[i].ans_id,
          ans_value: answer[i].ans_value,
          image: answer[i].image,
          isCorrect: answer[i].isCorrect
        };
        this.form.answer.push(reqData);
        this.form.answer_text[i] = answer[i].ans_value;
      }
      if (this.form.answer[index].isCorrect === false) {
        this.form.answer[index].isCorrect = true;
        this.isTrueSet[index] = true;
      } else {
        this.form.answer[index].isCorrect = false;
        this.isTrueSet[index] = false;
      }
    },

    getCorrectAnswer(index) {
      const id_question = this.editQuestion.data.answer;
      const answer = this.form.answer;
      this.form.answer = [];

      // update du lieu
      for (let i = 0; i < this.form.number_answer; i++) {
        // lay id update
        if (!this.form.id_ans_update.includes(i)) {
          this.form.id_ans_update.push(i);
        }
        const reqData = {
          ans_id: id_question[i].ans_id,
          ans_value: answer[i].ans_value,
          image: answer[i].image,
          isCorrect: false
        };
        this.isTrueSet[i] = false;
        this.form.answer.push(reqData);
        this.form.answer_text[i] = answer[i].ans_value;
      }
      this.isTrueSet[index] = true;
      this.form.answer[index]["ans_id"] = id_question[index].ans_id;
      this.form.answer[index]["isCorrect"] = true;
    },
    getCorrectAnswerReset() {
      const id_question = this.editQuestion.data.answer;
      const answer = this.form.answer;
      this.form.answer = [];

      // update du lieu
      for (let i = 0; i < this.form.number_answer; i++) {
        // lay id update
        if (!this.form.id_ans_update.includes(i)) {
          this.form.id_ans_update.push(i);
        }
        const reqData = {
          ans_id: id_question[i].ans_id,
          ans_value: answer[i].ans_value,
          image: answer[i].image,
          isCorrect: false
        };
        this.isTrueSet[i] = false;
        this.form.answer.push(reqData);
        this.form.answer_text[i] = answer[i].ans_value;
      }
    },

    // so luong cau tra loi
    numberAnswerOfQuestion(e) {
      const answer = this.form.answer;
      if (e.target.options.selectedIndex > -1) {
        let numberOfAnswerSelect = parseInt(
          e.target.options[e.target.options.selectedIndex].outerText
        );
        let numberOfAnswerRender = parseInt(
          this.editQuestion.data.answer.length
        );

        this.form.number_answer = numberOfAnswerSelect;

        // neu so luong dap an hien tai < dap an dc chon
        if (numberOfAnswerRender < numberOfAnswerSelect) {
          for (
            numberOfAnswerRender;
            numberOfAnswerRender < numberOfAnswerSelect;
            numberOfAnswerRender++
          ) {
            const reqData = {
              ans_id: numberOfAnswerRender + 1,
              // ans_value: null,
              // image: null,
              isCorrect: false
            };
            this.editQuestion.data.answer.push(reqData);
          }
        }
        // neu so luong dap an hien tai > dap an dc chon
        if (numberOfAnswerRender > numberOfAnswerSelect) {
          for (
            numberOfAnswerRender;
            numberOfAnswerRender > numberOfAnswerSelect;
            numberOfAnswerRender--
          ) {
            this.editQuestion.data.answer.pop();
          }
        }

        // tao form dap an
        this.form.answer = [];
        // neu dap an hien tai > dap an duoc chon
        if (numberOfAnswerRender > numberOfAnswerSelect) {
          for (let i = 0; i < numberOfAnswerSelect; i++) {
            const reqData = {
              ans_id: i + 1,
              ans_value: answer[i].ans_value,
              image: answer[i].image,
              isCorrect: answer[i].isCorrect
            };
            this.form.answer.push(reqData);
          }
        } else {
          // neu dap an hien tai < dap an duoc chon
          for (let i = 0; i < numberOfAnswerSelect; i++) {
            if (i < answer.length) {
              const reqData = {
                ans_id: i + 1,
                ans_value: answer[i]?.ans_value,
                image: answer[i]?.image,
                isCorrect: answer[i]?.isCorrect
              };
              this.form.answer.push(reqData);
            } else {
              const reqData = {
                ans_id: i + 1,
                ans_value: null,
                image: null,
                isCorrect: false
              };
              this.form.answer.push(reqData);
            }
          }
        }
        this.updateCorrectAnswer++;

        // set alphabet <-> number
        for (let i = 0; i < this.editQuestion.data.answer.length; i++) {
          this.editQuestion.data.answer[i].ans_id = this.valueTypeOfAnswers[
            this.typeOfAnswer
          ][i];
          this.form.answer[i].ans_id = this.valueTypeOfAnswers[
            this.typeOfAnswer
          ][i];
          this.imageReRender++;
        }
      }
    },
    // so luong cau tra loi default = 4;
    numberAnswerOfQuestionDefault(e) {
      const answer = this.form.answer;
      let numberOfAnswerSelect = e;
      let numberOfAnswerRender = parseInt(this.editQuestion.data.answer.length);

      this.form.number_answer = numberOfAnswerSelect;

      // neu so luong dap an hien tai < dap an dc chon
      if (numberOfAnswerRender < numberOfAnswerSelect) {
        for (
          numberOfAnswerRender;
          numberOfAnswerRender < numberOfAnswerSelect;
          numberOfAnswerRender++
        ) {
          const reqData = {
            ans_id: numberOfAnswerRender + 1,
            ans_value: null,
            image: null,
            isCorrect: false
          };
          this.editQuestion.data.answer.push(reqData);
        }
      }
      // neu so luong dap an hien tai > dap an dc chon
      if (numberOfAnswerRender > numberOfAnswerSelect) {
        for (
          numberOfAnswerRender;
          numberOfAnswerRender > numberOfAnswerSelect;
          numberOfAnswerRender--
        ) {
          this.editQuestion.data.answer.pop();
        }
      }

      // tao form dap an
      this.form.answer = [];
      // neu dap an hien tai > dap an duoc chon
      if (numberOfAnswerRender > numberOfAnswerSelect) {
        for (let i = 0; i < numberOfAnswerSelect; i++) {
          const reqData = {
            ans_value: this.editQuestion.data.answer[i].ans_value,
            image: this.editQuestion.data.answer[i].image,
            ans_id: i + 1,
            isCorrect: this.editQuestion.data.answer[i].isCorrect
          };
          this.form.answer.push(reqData);
        }
      } else {
        // neu dap an hien tai < dap an duoc chon
        for (let i = 0; i < numberOfAnswerSelect; i++) {
          if (i < numberOfAnswerRender) {
            const reqData = {
                ans_id: i + 1,
                ans_value: answer[i]?.ans_value,
                image: answer[i]?.image,
                isCorrect: answer[i]?.isCorrect
              };
            this.form.answer.push(reqData);
          } else {
            const reqData = {
                ans_id: i + 1,
                ans_value: null,
                image: null,
                isCorrect: false
              };
            this.form.answer.push(reqData);
          }
        }
      }
      this.updateCorrectAnswer++;

      // set alphabet <-> number
      for (let i = 0; i < this.editQuestion.data.answer.length; i++) {
        this.editQuestion.data.answer[i].ans_id = this.valueTypeOfAnswers[
          this.typeOfAnswer
        ][i];
        this.form.answer[i].ans_id = this.valueTypeOfAnswers[this.typeOfAnswer][
          i
        ];
        this.imageReRender++;
      }
    },
    // the loai cau hoi
    async typeOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.type = parseInt(e.target.options.selectedIndex);
        this.editQuestion.data.type = e.target.options[
          this.form.type
        ].outerText.trim();
      }
      // default alphabet:0 / text:1
      this.alphabetOfQuestionDefault(this.typeOfAnswer ? this.typeOfAnswer : 0);
      this.numberAnswerOfQuestionDefault(this.form.answer.length ? this.form.answer.length : 4);
      this.getCorrectAnswerReset();
      this.answerTypeOfQuestionDefault(this.editQuestion.data.isText ? this.editQuestion.data.isText : true)
      this.resetAnswer();
      this.editQuestion.data.manyAnswer = this.editQuestion.data.manyAnswer ? this.editQuestion.data.manyAnswer : 4;
      this.imageReRender++;

      // lay lai danh sach tags khi thay doi dang cau hoi:
        await this.$store.dispatch("question/changeListTags", {type: this.editQuestion.data.type}); // lay data tu api
       // console.log(this.changeListTags);
       this.optionsTags = this.changeListTags.data; // this.changeListTags : khai bao trong computed
       this.tagsSelected = [];
       // End lay lai danh sach tags khi thay doi dang cau hoi:

    },
    // alphabet cau hoi
    alphabetOfQuestionDefault(type) {
      this.typeOfAnswer = type;
      let valueSelected = type;

      for (let i = 0; i < this.editQuestion.data.answer.length; i++) {
        this.editQuestion.data.answer[i].ans_id = this.valueTypeOfAnswers[
          valueSelected
        ][i];
        this.editQuestion.data.answer[i].isCorrect = false;
      }
      this.imageReRender++;
    },
    // alphabet cau hoi default
    alphabetOfQuestion(e) {
      let valueSelected = e.target.options.selectedIndex;
      this.typeOfAnswer = e.target.options.selectedIndex;
      for (let i = 0; i < this.editQuestion.data.answer.length; i++) {
        this.editQuestion.data.answer[i].ans_id = this.valueTypeOfAnswers[
          valueSelected
        ][i];
        this.editQuestion.data.answer[i].isCorrect = false;
      }
      this.imageReRender++;
    },
    // trang thai cau hoi
    statusOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.editQuestion.data.status = e.target.options.selectedIndex;
      }
    },
    // do kho cau hoi
    difficultyOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.editQuestion.data.difficulty =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
    },
    // so luong cau tra loi chinh xac
    manyAnswerOfQuestion(e) {
      let answerOptionSelected = e.target.options.selectedIndex;
      if (e.target.options.selectedIndex > -1) {
        this.valueAnswerOption = answerOptionSelected;
      }
      if (answerOptionSelected == 1) {
        this.editQuestion.data.answer_option = "Multiple choice";
      }
      if (answerOptionSelected == 0) {
        this.editQuestion.data.answer_option = "One choice";
      }
      const answer = this.form.answer;
      this.form.answer = [];
      for (let i = 0; i < this.form.number_answer; i++) {
        // lay id update
        if (!this.form.id_ans_update.includes(i)) {
          this.form.id_ans_update.push(i);
        }
        const reqData = {
          ans_id: answer[i].ans_id,
          ans_value: answer[i].ans_value,
          image: answer[i].image,
          isCorrect: answer[i].isCorrect
        };
        this.form.answer.push(reqData);
        this.form.answer_text[i] = answer[i].ans_value;
      }
    },
    // the loai dap an
    answerTypeOfQuestion(e) {
      let selected = "";
      if (e.target.options.selectedIndex > -1) {
        selected = e.target.options.selectedIndex;
      }
      if (selected == 0) {
        this.isText = true;
        this.editQuestion.data.isText = true;
      }
      if (selected == 1) {
        this.isText = false;
        this.editQuestion.data.isText = false;
      }
      this.imageReRender++;
    },
    answerTypeOfQuestionDefault(isText){
      this.isText = isText;
      this.editQuestion.data.isText = isText;
      this.imageReRender++;
    },
    resetAnswer(){
      const answer = this.form.answer;
      this.form.answer = [];
      for (let i = 0; i < this.form.number_answer; i++) {
        // lay id update
        if (!this.form.id_ans_update.includes(i)) {
          this.form.id_ans_update.push(i);
        }
        const reqData = {
          ans_id: answer[i].ans_id,
          ans_value: answer[i].ans_value,
          image: answer[i].image,
          isCorrect: answer[i].isCorrect
        };
        this.form.answer.push(reqData);
        this.form.answer_text[i] = answer[i].ans_value;
        this.answerUpload[i] = "";
        this.editQuestion.data.answer[i].image = "";
        this.editQuestion.data.answer[i].image_answer_s3 = "";
        this.imageReRender += 1;
      }
    },
    charCount: function(e, index) {
      const id_question = this.editQuestion.data.answer;
      const answer = this.form.answer;
      this.form.answer = [];
      // update du lieu
      for (let i = 0; i < this.form.number_answer; i++) {
        // lay id update
        if (!this.form.id_ans_update.includes(i)) {
          this.form.id_ans_update.push(i);
        }
        const reqData = {
          ans_id: id_question[i].ans_id,
          ans_value: id_question[i].ans_value,
          image: answer[i].image,
          isCorrect: answer[i].isCorrect
        };
        this.form.answer.push(reqData);
        this.form.answer_text[i] = answer[i].ans_value;
      }
      this.form.answer_text[index] = e;
      this.form.answer[index].ans_value = e;
    },
    charCountTitle: function() {
      this.editQuestion.data.title.length = this.editQuestion.data.title.length;
    },
    handleAudioUpload(event) {
      // check validate
      let fileUpload = event.target.files[0].name.split(".");
      let typeOfFile = fileUpload[fileUpload.length - 1];

      if (event.target.files[0].size / 1048576 > 10) {
          this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
      if (typeOfFile === "mp3") {
        this.audioUpload = event.target.files[0];
        this.form.audio_path = this.audioUpload;

        this.audioUpload = URL.createObjectURL(this.audioUpload);
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    handleFileUpload(e) {
      // check validate
      let fileUpload = e.target.files[0].name.split(".");
      let typeOfFile = fileUpload[fileUpload.length - 1];

      if (
        typeOfFile === "mp4" ||
        typeOfFile === "jpg" ||
        typeOfFile === "jpeg" ||
        typeOfFile === "png"
      ) {
        if (e.target.files[0].size / 1048576 > 10) {
          this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
          });
          return;
        }
        if (typeOfFile === "mp4") {
          this.file = e.target.files[0];
          this.form.video_path = this.file;
          this.file = URL.createObjectURL(this.file);
        } else {
          const img = e.target.files[0];
          this.form.image_path = img;
          this.imageUpload = URL.createObjectURL(img);
        }
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    uploadImageAnswer(index) {
      document.getElementById("uploadImage" + index).click();
    },
    handleAnswerUpload(e, index) {
      // check validate
      let fileUpload = e.target.files[0].name.split(".");
      let typeOfFile = fileUpload[fileUpload.length - 1];

      if (
        typeOfFile === "jpg" ||
        typeOfFile === "jpeg" ||
        typeOfFile === "png"
      ) {
        this.editQuestion.data.answer[
          index[0]
        ].ans_id = this.valueTypeOfAnswers[this.typeOfAnswer][index[0]];
        const img = e.target.files[0];
        this.form.id_ans_update[index[0]] = index[0];
        this.form.image[index[0]] = img;
        this.answerUpload[index[0]] = URL.createObjectURL(img);
        this.imageReRender += 1;
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    previewVideo() {
      let video = document.getElementById("video-preview");
      let reader = new FileReader();

      reader.readAsDataURL(this.file);
      reader.addEventListener("load", function() {
        video.src = reader.result;
      });
    },
    embed() {
      if (
        this.form.embed_image_video.includes("https://") ||
        this.form.embed_image_video.includes("http://")
      ) {
        this.embedUpload = this.form.embed_image_video;
        document.getElementById("embedUpload").innerHTML =
          '<embed width="500" height="250" src="' +
          this.embedUpload +
          '"  frameborder="0"   allowfullscreen></embed>';
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    audioEmbedLeft() {
      if (
        this.form.embed_audio.includes("<iframe") &&
        this.form.embed_audio.includes("></iframe>") &&
        this.form.embed_audio.includes("src=")
      ) {
        this.embedAudio = this.form.embed_audio;
        document.getElementById("audio_embed_view_topic").innerHTML = this.embedAudio;
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    removeFile: function() {
      this.editQuestion.data.image_s3 = "";
      this.editQuestion.data.image_path = "";
      this.imageUpload = "";
      this.videoUpload = "";
      this.file = "";
      this.form.video_path = "";
      this.form.image_path = "";
      this.editQuestion.data.video_s3 = "";
      this.editQuestion.data.video_path = "";
    },
    removeEmbed: function() {
      this.embedUpload = "";
      this.editQuestion.data.embed_image_video = "";
      this.form.embed_image_video = "";
      document.getElementById("embedUpload").innerHTML = "";
    },
    removeAudio: function() {
      this.editQuestion.data.audio_path = "";
      this.editQuestion.data.audio_s3 = "";
      this.audioUpload = "";
      this.form.audio_path = "";
      document.getElementById("upload-audio-input-edit-topic").value = null;
    },
    removeEmbedAudio: function() {
      this.editQuestion.data.embed_audio = "";
      this.form.embed_audio = "";
      this.embedAudio = "";
      document.getElementById("embed_audio_link").value = null;
      document.getElementById("audio_embed_view_topic").innerHTML = null;
    },
    removeAnswerImage: function(index) {
      this.answerUpload[index] = "";
      this.editQuestion.data.answer[index].image = "";
      this.editQuestion.data.answer[index].image_answer_s3 = "";
      this.imageReRender += 1;
    },
    hideModal() {
      this.$bvModal.hide("modal-edit-question");
    },
    async EditQuestions() {
      this.loading = true;
      this.disable = false;
      var id_ans_update = [];
      var answer_text = [];
      var answer_image = [];
      var manyAnswer = this.editQuestion.data.answer.length;

      let data = new FormData();
      for (let i = 0; i < this.cateSelected.length; i++) {
        this.form.category[i] = this.cateSelected[i]["category"];
      }

      for (let i = 0; i < this.tagsSelected.length; i++) {
        this.form.tags[i] = this.tagsSelected[i]["id"];
      }

      if (this.isText == true) {
        this.form.answer_text = this.form.answer_text.filter(function(el) {
          return el != null;
        });
        this.form.answer_text.forEach((el, index) => {
          if (index < manyAnswer) {
            answer_text.push(el);
          }
        });
        data.append("answer_text", JSON.stringify(answer_text));
      } else {
        this.form.image.forEach((el, index) => {
          if (index < manyAnswer) {
            answer_image.push(el);
          }
        });
        this.form.image.map((answer_image, index) => {
            if(index < manyAnswer){
              data.append("image[]", answer_image, answer_image.name)
            }
          }
        );
        data.append("answer_text", null);
      }
      this.form.id_ans_update = this.form.id_ans_update.filter(function(el) {
        return el != null;
      });
      this.form.id_ans_update.forEach((el) => {
        if (el < manyAnswer) {
          id_ans_update.push(el);
        }
      });

      data.append("type", this.editQuestion.data.type);
      data.append("title", this.editQuestion.data.title);
      data.append("category", JSON.stringify(this.form.category));
      data.append("status", this.editQuestion.data.status);
      data.append("score", this.editQuestion.data.score);
      data.append("difficulty", this.editQuestion.data.difficulty);
      data.append("tags", JSON.stringify(this.form.tags));
      data.append(
        "explain",
        this.editQuestion.data.explain == null
          ? ""
          : this.editQuestion.data.explain
      );
      data.append(
        "explain_path",
        this.editQuestion.data.explain_path == null
          ? ""
          : this.editQuestion.data.explain_path
      );
      data.append("image_path", this.form.image_path);
      data.append("video_path", this.form.video_path);
      data.append(
        "embed_image_video",
        this.form.embed_image_video == null ? "" : this.form.embed_image_video
      );
      data.append(
        "audio_path",
        this.form.audio_path == null ? "" : this.form.audio_path
      );
      data.append(
        "embed_audio",
        this.form.embed_audio == null ? "" : this.form.embed_audio
      );
      data.append("answer_option", this.editQuestion.data.answer_option);
      data.append("id_topic", this.form.id_topic);
      data.append("answer", JSON.stringify(this.form.answer));

      data.append("manyAnswer", manyAnswer);
      data.append("id_ans_update", JSON.stringify(id_ans_update));

      this.$root.$loading.start();
      await this.$store.dispatch("question/editQuestion", [
        data,
        this.editQuestion.data.idQues
      ]);
      this.loading = true;
      const apiRes = this.$store.state.question.responseQuestion;
      const errors =
        apiRes?.errors?.title ||
        apiRes?.errors?.score || { message: apiRes?.message } ||
        "";
      const errorFields = Object.values(errors);
      if (this.$store.state.question.responseQuestion.code !== 422) {
        await this.$store.dispatch("topics/getOneTopicTest", this.rowTopicItem);
        this.callback();
        this.$root.toast(
          this.$t("commons.label.create_success_title"),
          "success",
          this.$t("questions_create.message.edit_success")
        );
        this.disable = true;
        this.loading = false;
      } else {
        this.$root.toast(
          this.$t("questions_create.message.edit_false"),
          "danger",
          this.$t(`msg["${errorFields}"]`)
        );
        this.loading = false;
        this.disable = true;
        return;
      }
      this.$bvModal.hide("modal-edit-question");
      this.$root.$loading.finish();
    },
    renderQuestion() {
      this.categories = this.category;
      var editQuestions = this.editQuestion.data;
      for (let i = 0; i < editQuestions.category.length; i++) {
        const reqData = { category: editQuestions.category[i] };
        this.cateSelected.push(reqData);
      }

      if(editQuestions.tags !== null){

        for (let i = 0; i < editQuestions.tags.length; i++) {
            this.optionsTags.forEach((item)=>{
                if(editQuestions.tags[i] === item.id){
                    const opt = {id : item.id, name: item.name};
                    this.tagsSelected.push(opt);
                }
            })

        }
      }


      for (let i = 0; i < editQuestions.answer.length; i++) {
        this.isTrueSet[i] =
          editQuestions.answer[i].isCorrect === true ? true : false;
      }

      if (editQuestions.type == "Listening") {
        this.form.type = 0;
      } else if (editQuestions.type == "Writing") {
        this.form.type = 1;
      } else if (editQuestions.type == "Reading") {
        this.form.type = 2;
      } else if (editQuestions.type == "Speaking") {
          this.form.type = 3;
      }
      this.form.image_path = editQuestions.image_path
        ? editQuestions.image_path
        : "";
      this.form.answer = editQuestions.answer;
      this.form.video_path = editQuestions.video_path
        ? editQuestions.video_path
        : "";
      this.form.audio_path = editQuestions.audio_path
        ? editQuestions.audio_path
        : "";
      this.form.embed_audio = editQuestions.embed_audio
        ? editQuestions.embed_audio
        : "";
      this.isText = editQuestions.isText == 1 ? true : false;
      this.valueTypeOfAnswer = editQuestions.isText == 1 ? 1 : 0;
      if(editQuestions.type !== "Writing" && editQuestions.type !== "Speaking"){
        this.typeOfAnswer = editQuestions.answer[0].ans_id == 1 ? 1 : 0;
      }
      this.valueAnswerOption =
        editQuestions.answer_option == "One choice" ? 0 : 1;
      this.form.embed_image_video = editQuestions.embed_image_video
        ? editQuestions.embed_image_video
        : "";
      this.form.status = editQuestions.status == 0 ? 0 : 1;
      this.form.number_answer = editQuestions.manyAnswer;
      this.form.id_topic = editQuestions.id_topic ? editQuestions.id_topic : "";
      if (this.cateSelected.length != 0) {
        this.renderData++;
      }
      this.renderData++;
    },
    checkCategoryPermission(item) {
      // Không phải tài khoản giáo viên B2B thì không cần check quyền category
            const businessId = Number(this.user?.business_id || 0);
            if (businessId <= 0) {
                return;
            }
            // ENd check tài khoản giáo viên
      const allowedIds = this.categoryIdsAllow
        .split(",")
        .map(id => String(id).trim())
        .filter(Boolean);

      const categoryId = String(item.id);

      if (!allowedIds.includes(categoryId)) {
        this.$nextTick(() => {
          this.cateSelected = this.cateSelected.filter(
            cate => String(cate.id) !== categoryId
          );
        });

        this.$root.toast(
          this.$t(`msg["title_notification"]`),
          "danger",
          this.$t(`msg["content_noti"]`),
          
        );
      }
    },
  },
  async created() {

    // Lay danh sach option Tags
    await this.$store.dispatch("question/changeListTags", {type: this.editQuestion.data.type});
    this.optionsTags = this.changeListTags.data;
    // End Lay danh sach option Tags

    await this.$root.$loading.start();
    await this.$store.dispatch("config/getCategory");
    this.loading = true;
    await this.renderQuestion();
    this.loading = false;

    this.$root.$loading.finish();
  }
};
</script>

<style>
@import "../../../assets/scss/Questions.scss";
#removeEmbed1 {
    position: absolute;
    right: 20px;
    z-index: 1;
    top: 100px;
    border-radius: 50px;
    width: 30px;
}
/*.question-input__textArena div.edit-question{*/
/*    width: 100%;*/
/*    background: #e5eaff;*/
/*    border-radius: 10px;*/
/*    border: none;*/
/*      padding: 20px;*/
/*    font-size: 15px;*/
/*}*/
.question-input__textArena div.edit-question.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){
    width: 539px;
    resize: vertical;
}
</style>
